import {keepPreviousData, useQuery} from '@tanstack/react-query';

import {useAppSelector} from '@/hooks/useRedux';
import {fetchCollectInfoForTrack} from '@/modules/Collect/api/collect';
import {selectActiveUserSigner} from '@/store/user';
import {QueryKeys} from '@/types/queryKeys';

export interface ICollectOfferParams {
  trackId: string;
  userAddress?: string;
  quantity?: number;
  referralAddress?: string;
}

interface QueryOptions {
  keepPreviousData?: boolean;
  enabled?: boolean;
}

export const useTrackCollectInfoQuery = (
  {trackId, userAddress, referralAddress, quantity = 1}: ICollectOfferParams,
  {
    enabled = true,
    keepPreviousData: _keepPreviousData = false,
  }: QueryOptions = {},
) => {
  const internalAddress = useAppSelector(selectActiveUserSigner)?.address;

  // fallback to internal address to show offer data even before signing in
  const address = userAddress || internalAddress;

  const query = useQuery({
    queryKey: [QueryKeys.collectInfoForTrack, trackId, address, quantity],
    queryFn: () =>
      fetchCollectInfoForTrack(trackId, address!, quantity, referralAddress),
    enabled: !!address && enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    gcTime: 1000 * 60,
    staleTime: 0,
    placeholderData: _keepPreviousData ? keepPreviousData : undefined,
  });

  return {
    collectInfo: query.data,
    query,
  };
};
